export function getDataByCode(db, type, code) {
    var rtn;
    for (let el of db[type]) {
        if (el.code === code) {
            rtn = el;
        }
    }
    return rtn;
}
export function getDataByID(db, type, id) {
    var rtn;
    for (let el of db[type]) {
        if (el.id === id) {
            rtn = el;
        }
    }
    return rtn;
}

export const orderList = [
    "long sofa",
    "sofa",
    "loveseat",
    "chair",
    "lounge",
    "junior lounge",
    "sectional",
    "sectional a",
    "sectional b",
    "as shown",
    "armless",
    "lounge arm",
    "junior lounge arm",
    "one arm",
    "one arm double",
    "ottoman",
    "corner",
]

export const modularObj = {
    id: "modularBTN",
    name: { fr: "Modulaire", en: "Modular" },
    code: "modular",
    type: "std"
}